module.exports = __webpack_public_path__ + "img/bg.5766e2f6.png";